var _a;
// import './class/Dialog'
import Accordion from './class/Accordion';
// import GlobalHeader from './class/GlobalHeader'
// import Tabs from './class/Tabs'
// import insertBase64Mailto from './function/insert-base64-mailto'
// new GlobalHeader()
document
    .querySelectorAll('.accordion')
    .forEach((i) => new Accordion(i));
// document.querySelectorAll<HTMLElement>('.tabs').forEach((i) => new Tabs(i))
// insertBase64Mailto('bWluYW1vdG9Ad29yZHByZXNzLmxvY2FsaG9zdA==', '.mailto')
(_a = document
    .querySelector('.to-page-top')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (e) {
    e.preventDefault();
    scrollTo({ top: 0, behavior: 'smooth' });
});
